<template>
	<layout-header></layout-header>
	
    <!-- Page Wrapper -->
	<div class="page-wrapper">
		<div class="content content-two">
            <div class="container ">
				<div class="/pages/notification">
					<div class="d-flex justify-content-between mb-3">
						<a href="javascript:void(0);" class="btn btn-white  border"><i class="ti ti-calendar me-2"></i>Today</a>
						<div>
							<a href="javascript:void(0);" class="btn btn-light  me-2"><i class="ti ti-check me-2"></i>Mark all as read</a>
							<a href="javascript:void(0);" class="btn btn-dark "><i class="ti ti-trash me-2"></i>Delete All</a>
						</div>
					</div>
					<div class="row">
						<div class="col-xxl-12 col-lg-12">
							<div class="card">
								<div class="card-body p-4">
									<div class="d-md-flex align-items-center">
										<div class="d-sm-flex flex-fill">
											<div class="d-flex justify-content-between">
												<span class="avatar avatar-lg me-3">
													<img src="@/assets/img/profiles/avatar-36.jpg" class="rounded-circle img-fluid" alt="User Image">
												</span>
												<div class="d-flex flex-column">
													<div class="d-flex align-items-center">
														<h6 class="fs-16 fw-medium me-2">Ray Arnold requested access to UNIX directory tree hierarchy</h6>
														<span><i class="ti ti-point-filled text-primary"></i></span>
													</div>
													<span class="fs-12 mb-2">1m ago</span>
													<div>
														<a href="javascript:void(0);" class="btn btn-light me-2">Decline</a>
														<a href="javascript:void(0);" class="btn btn-dark">Accept</a>
													</div>
												</div>
											</div>
										</div>
										<div>
											<a href="javascript:void(0);" class="btn btn-light me-2">Delete</a>
										</div>
									</div>
								</div>							
							</div>
						</div>
						<div class="col-xxl-12 col-lg-12">
							<div class="card">
								<div class="card-body p-4">
									<div class="d-md-flex align-items-center">
										<div class="d-sm-flex flex-fill">
											<div class="d-flex justify-content-between">
												<span class="avatar avatar-lg me-3">
													<img src="@/assets/img/profiles/avatar-47.jpg" class="rounded-circle img-fluid" alt="User Image">
												</span>
												<div class="d-flex flex-column">
													<div class="d-flex align-items-center">
														<h6 class="fs-16 fw-medium">John Hammond created Isla Nublar SOC2 compliance report</h6>
													</div>
													<span class="fs-12 mb-2">1m ago</span>
												</div>
											</div>
										</div>
										<div>
											<a href="javascript:void(0);" class="btn btn-light me-2">Delete</a>
										</div>
									</div>
								</div>							
							</div>
						</div>
						<div class="col-xxl-12 col-lg-12">
							<div class="card">
								<div class="card-body p-4">
									<div class="d-md-flex align-items-center">
										<div class="d-sm-flex flex-fill">
											<div class="d-flex justify-content-between">
												<span class="avatar avatar-lg me-3">
													<img src="@/assets/img/profiles/avatar-25.jpg" class="rounded-circle img-fluid" alt="User Image">
												</span>
												<div class="d-flex flex-column">
													<div class="d-flex align-items-center">
														<h6 class="fs-16 fw-medium">Lex Murphy left 6 comments on Isla Nublar SOC2 compliance report</h6>
													</div>
													<span class="fs-12 mb-2">1m ago</span>
												</div>
											</div>
										</div>
										<a href="javascript:void(0);" class="toottip bg-light d-flex justify-content-center align-items-center rounded-circle"  data-bs-toggle="tooltip" data-bs-placement="right" title="Mark as read"><i class="ti ti-dots-vertical"></i></a>
									</div>
								</div>							
							</div>
						</div>
					</div>
				</div>
            </div>
		</div>
	</div>
	<!-- /Page Wrapper -->
</template>